var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wf-right"},[(_vm.is_login)?_c('UserIntegral'):_vm._e(),_c('VideoPlay'),_c('NoticeMessage'),_c('AccountInfo')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }